import React from "react";
import ReactDOMClient from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If the root element already contains prerendered HTML (from react-snap at build time),
// hydrate it. Otherwise do a fresh client-side render. This preserves prerendered
// content for bots without JS while keeping React fully interactive for real users.
if (rootElement.hasChildNodes()) {
  ReactDOMClient.hydrateRoot(rootElement, tree);
} else {
  ReactDOMClient.createRoot(rootElement).render(tree);
}
